module.exports = __webpack_public_path__ + "media/images/color_admin_v3/gallery/gallery-3-5597350bd3ba81dee80278d9943f5678.jpg";